import { connect } from 'react-redux';
import { selectedTabIndexChanged, stepValidationStatusChanged } from '../actions';
import ReviewPageStep from '../components/review/ReviewPageStep';
import { getReviewPageStep } from '../selectors';

const mapStateToProps = state => getReviewPageStep(state);

const mapDispatchToProps = dispatch => ({
    onSelectedTabIndexChanged: index => dispatch(selectedTabIndexChanged(index)),
    onStepValidationStatusChanged: stepValidationStatus => dispatch(stepValidationStatusChanged(stepValidationStatus)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { pageSteps, mode, ...restStateProps } = stateProps;
    const { onSelectedTabIndexChanged, ...restDispatchProps } = dispatchProps;

    const onEditStep = stepId => {
        const index = pageSteps.indexOf(stepId);
        if (index >= 0) {
            onSelectedTabIndexChanged(index);
        }
    };

    return {
        ...ownProps,
        ...restStateProps,
        ...restDispatchProps,
        onEditStep,
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ReviewPageStep);
